var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"columns m-0"},[_c('div',{staticClass:"side-bar-container",class:_vm.isExpanded
          ? 'column is-2 sidebar-expanded'
          : 'column is-1 sidebar-collapsed'},[_c('side-bar',{on:{"expand":_vm.handleExpand}})],1),_vm._v(" "),_c('div',{staticClass:"column p-0"},[_c('navbar',{staticClass:"navbar-container p-3",on:{"open-login":_vm.handleLoginActive}}),_vm._v(" "),_c('login-modal'),_vm._v(" "),_c('div',{staticClass:"container is-fluid"},[_c('nuxt')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }